import { signal } from '@preact/signals';

export const showSplash = signal<boolean>(true);
export const isFullscreen = signal<boolean>(!!document.fullscreenElement);

document.addEventListener('fullscreenchange', () => {
  isFullscreen.value = !!document.fullscreenElement;
});

export const goFullscreen = (): void => {
  document.documentElement.requestFullscreen().catch(() => {
    // Fullscreen denied or unsupported
  });
};

export const dismissSplash = (): void => {
  showSplash.value = false;
  goFullscreen();
};
